import { render, staticRenderFns } from "./EditServiceRequest.vue?vue&type=template&id=32e80394"
import script from "./EditServiceRequest.vue?vue&type=script&lang=js"
export * from "./EditServiceRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports